import { render, staticRenderFns } from "./AddBookings.vue?vue&type=template&id=3f1b6f84&scoped=true"
import script from "./AddBookings.vue?vue&type=script&lang=js"
export * from "./AddBookings.vue?vue&type=script&lang=js"
import style0 from "./AddBookings.vue?vue&type=style&index=0&id=3f1b6f84&prod&scoped=true&lang=css"
import style1 from "./AddBookings.vue?vue&type=style&index=1&id=3f1b6f84&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f1b6f84",
  null
  
)

export default component.exports